import Swiper from 'swiper';

const swiper1 = new Swiper('.background-swiper', {
	loop: true,
	slidesPerView: 3,
	allowTouchMove: false,
});

const swiper2 = new Swiper('.foreground-swiper', {
	loop: true,
	initialSlide: 1,
	preventInteractionOnTransition: true,
	allowTouchMove: false,
});


const swiper3 = new Swiper('.background-swiper-testimonial', {
	loop: true,
	slidesPerView: 3,
	allowTouchMove: false,
});

const swiper4 = new Swiper('.foreground-swiper-testimonial', {
	loop: true,
	initialSlide: 1,
	preventInteractionOnTransition: true,
	allowTouchMove: false,
});

window.swiper1 = swiper1;
window.swiper2 = swiper2;
window.swiper3 = swiper3;
window.swiper4 = swiper4;
